<template>
  <vs-popup :active.sync="isActive" id="discount">

    <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
      <vs-button color="transparent" class="payment-label bg-primary2 text-white w-full" icon-pack="feather"
        icon="icon-percent">
        İndirim Seçenekleri
      </vs-button>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="info-row" v-if="activePersonel">
      <vs-col vs-type="flex" class="w-auto">
        <p class="text-primary bold mr-3">
          Personal Adı :
        </p>
        <p class="text-primary">
          {{activePersonel.name}}
        </p>
      </vs-col>
      <vs-col vs-type="flex" class="w-auto ml-auto">
        <p class="text-primary">{{currentDate}}</p>
      </vs-col>
      <vs-col vs-type="flex" class="w-auto ml-3">
        <p class="text-primary">{{currentTime}}</p>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="px-2 py-3" vs-justify="center" style="zoom: 90%;">
      <vs-col vs-type="flex" vs-w="7">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="block" vs-w="12" style="height:86%;">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <vs-col vs-type="flex" vs-w="5" vs-justify="center">
                <div class="w-full half-friendly-border bg-secondary sale-box-shadow discount-old-title">
                  <span class="text-dark bold underline">
                    Ürün Tutarı
                  </span>
                  <span class="text-primary bold">
                    {{$toCurrency(priceToDiscount)}}
                  </span>
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-w="5" vs-offset="1" v-if="enteredPrice > 0">
                <div class="w-full half-friendly-border bg-secondary sale-box-shadow discount-old-title">
                  <span class="text-dark bold underline">
                    Yeni Ürün Tutarı
                  </span>
                  <span class="text-success bold">
                    {{(discountType == 0 ? priceToDiscount - (priceToDiscount * enteredPrice / 100) : priceToDiscount - enteredPrice).toFixed(2)}}
                    ₺
                  </span>
                </div>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="center">
              <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end">
                <vs-button @click="discountType = 0;enteredPriceStr = '';" color="transparent"
                  class="friendly-border sale-box-shadow text-white bold bg-primary2"
                  :class="{'bg-success' : discountType == 0, 'pay-attention' : discountType == null}">
                  Yüzde(%)
                </vs-button>
              </vs-col>
              <vs-col vs-type="flex" vs-w="5" vs-offset="0.25" vs-justify="flex-start">
                <vs-button @click="discountType = 1;
                enteredPriceStr = '';" color="transparent"
                  class="friendly-border sale-box-shadow text-white bold bg-primary2"
                  :class="{'bg-success' : discountType == 1, 'pay-attention' : discountType == null}">
                  Tutar(₺)
                </vs-button>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-4">
              <input style="display:none" type="text" name="username">
              <v-select type="select" class="w-full"  placeholder="İndirim Sebebi Giriniz." id="discountReason"
                v-model="selectedDiscountReason" disableBrowserAutocomplete :options="discountReasons" itemid="id" label="name"
                name="İndirim Sebebi" v-validate="'required|min:3'" push-tags />
              <span class="text-danger text-sm"
                v-show="errors.has('İndirim Sebebi')">{{ errors.first('İndirim Sebebi') }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-align="center" class="mt-4">
        <vs-textarea v-validate="required" name="Açıklama" v-model="discountDescription" label="Açıklama" />
      </vs-row>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-auto" vs-justify="space-between">
            <vs-col vs-type="flex" vs-w="5.75">
              <vs-button @click="getBack" size="large" icon="icon-arrow-left" icon-pack="feather" color="transparent"
                class="w-full half-friendly-border sale-box-shadow bg-secondary text-primary bold">
                Vazgeç
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-w="5.75">
              <vs-button size="large" color="transparent" @click="appendDiscount"
                :disabled="discountType == null || enteredPrice == 0 || selectedDiscountReason == null || discountDescription == ''"
                class="w-full half-friendly-border sale-box-shadow bg-success text-white bold">
                Uygula
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-w="4" vs-offset="0.5">
        <vs-row vs-type="block" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <div class="w-full calc-screen half-friendly-border px-5 py-1">
              <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
                <p class="bold calc-screen-entry-price" :class="{'text-dark' : discountType != null}"> -
                  {{enteredPriceStr}} {{discountType == 0 ? '%' : '₺'}}</p>
              </vs-row>
            </div>

            <vs-row vs-type="flex" vs-w="12">
              <vs-button color="transparent" :disabled="discountType == null"
                class="mt-2 w-full sale-box-shadow bg-secondary text-small border text-primary bold"
                @click="clearEnteredPrice">
                Temizle
              </vs-button>
            </vs-row>

            <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
              <vs-col vs-type="flex" vs-w="3.5" v-for="rate in rates" :key="rate.name" class="mt-2 px-3">
                <span @click="discountType != null ? spliceTotalPrice(rate.value) : null"
                  :class="{'disabled' : discountType == null}"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-5 border">
                  {{rate.name}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3.5" v-for="number in numbers" :key="number" class="mt-2">
                <span @click="discountType != null ? appendNumber(number) : null"
                  :class="{'disabled' : discountType == null}"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-5 border">
                  {{number}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7.75" class="mt-2 height-fit line-medium">
                <span @click="discountType != null ? enterZero() : null" :class="{'disabled' : discountType == null}"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-5 border">
                  {{0}}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="3.5" class="mt-2 height-fit line-medium">
                <span @click="discountType != null ? enterComma() : null" :class="{'disabled' : discountType == null}"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-5 border">
                  ,
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import { GetAllDiscountReason } from "@/api/DiscountReason.js";
  export default {
    props: {
      priceToDiscount: {
        type: Number,
        required: true
      },
      currentTime: {
        type: String,
        required: true
      },
      currentDate: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        selectedDiscountReason: null,
        discountDescription: '',
        isActive: false,
        discountType: 0,
        discountReasons: [
        ],
        numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
        numberRates: [{
            id: 1,
            value: 100,
            name: "İkram"
          },
          {
            id: 2,
            value: 50,
            name: "1/2"
          },
          {
            id: 3,
            value: 25,
            name: "1/4"
          }
        ],
        percentRates: [{
            id: 1,
            value: 100,
            name: "İkram"
          },
          {
            id: 2,
            value: 40,
            name: "40%"
          },
          {
            id: 3,
            value: 20,
            name: "20%"
          }
        ],
        enteredPrice: 0,
        enteredPriceStr: ""
      }
    },
    computed: {
      rates() {
        return this.discountType == 0 ? this.percentRates : this.numberRates;
      },
      activePersonel: function () {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
    },
    watch: {
      enteredPriceStr: function (newVal, oldVal) {
        if(newVal == "") {
          this.enteredPrice = 0;
          return;
        }
        let parsedPrice = parseFloat(newVal.replace(",", "."));
        if (this.discountType == 1) {
          if (parsedPrice > this.priceToDiscount) {
            this.enteredPriceStr = oldVal;
          } else {
            this.enteredPrice = parsedPrice;
          }
        }else if(this.discountType == 0){
          if (parsedPrice > 100) {
            this.enteredPriceStr = oldVal;
          } else {
            this.enteredPrice = parsedPrice;
          }
        }
      },
      isActive(val) {
        if (!val){
           this.initValues()
        }else{
          this.getdiscountReasons();
        };
      }
    },
    methods: {
      getdiscountReasons() {
        GetAllDiscountReason().then(res => {
          if (res && res.status == 200) {
            this.discountReasons = res.data;
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "İndirim Sebepleri Yüklenemedi !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "İndirim Sebepleri Yüklenemedi !"
            });
          }
        }).catch(error => {
          this.$fire({
              title: "Hata",
              text: "Sunucu Bağlantı Hatası !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      initValues() {
        this.selectedDiscountReason = null;
        this.discountDescription ='';
        this.discountType = 0;
        this.enteredPrice = 0;
        this.enteredPriceStr = "";
        this.$validator.reset();
        this.setSelectDefaultPaymentMethod();
      },
      appendDiscount() {
        if (this.$validator.validateAll()) {
          let discountObj = {
            originPrice: this.priceToDiscount,
            priceToDiscount: this.discountType == 1 ? this.enteredPrice : this.priceToDiscount * this.enteredPrice / 100,
            payedPrice: this.priceToDiscount - (this.discountType == 1 ? this.enteredPrice : this.priceToDiscount * this.enteredPrice / 100),
            value : this.enteredPrice,
            description : this.selectedDiscountReason.name,
            unit : this.discountType == 1 ? "₺" : "%",
            discountDescription : this.discountDescription
          };
        //  this.$store.dispatch('selfservice/CART_PRICE_UPDATE', discountObj)
          this.$emit("appendDiscount", discountObj);
          this.isActive = false;
        }
      },
      setSelectDefaultPaymentMethod(){
        this.$store.dispatch("selfservice/setSelectedPaymentMethod",this.$store.getters["selfservice/getPaymentMethods"][0]);
      },
      getBack() {
        this.isActive = false;
      },
      spliceTotalPrice(rate) {
        this.enteredPriceStr = "";
        let value = this.priceToDiscount * rate / 100;
        value = value.toFixed(2);
        value = value.replace(".", ",");
        if(this.discountType == 0) this.enterPriceData(rate);
        else if(this.discountType == 1) this.enterPriceData(value);
      },
      clearLastChar: function () {
        this.enteredPriceStr = this.enteredPriceStr.substring(0, this.enteredPriceStr.length - 1);
      },
      appendNumber: function (str) {
        this.enterPriceData(str);
      },
      clearEnteredPrice: function () {
        this.enteredPriceStr = "";
      },
      enterComma: function () {
        this.enterPriceData(",");
      },
      enterZero: function () {
        this.enterPriceData("0");
      },
      enterPriceData: function (val) {
        if (this.enteredPriceStr.includes(",")) {
          let split = this.enteredPriceStr.split(",");
          if (split[1].length > 1) {
            return;
          }
        }
        if (val === ",") {
          if (!this.enteredPriceStr.includes(",")) {
            if (this.enteredPriceStr.length === 0) {
              this.enteredPriceStr = this.enteredPriceStr + "0" + val;
            } else {
              this.enteredPriceStr = this.enteredPriceStr + val;
            }

          }
        } else if (val === "0") {
          if (this.enteredPriceStr.length > 0) {
            this.enteredPriceStr = this.enteredPriceStr + val;
          } else {
            return;
          }
        } else {
          this.enteredPriceStr = this.enteredPriceStr + val;
        }
      }
    },
    mounted(){
      let ex = document.querySelectorAll('[role="combobox"]');
      ex[0].name = "discountReasonInput";
    }
  }

</script>

<style>
 #discount .vs-popup .vs-popup--header {
    display: none;
  }

  #discount .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
  }

  #discount .vs-popup {
    border-radius: 2rem !important;
    width: 1000px!important;
  }
  .discount-old-title {
    justify-content: center;
    text-align: center;
    display: grid;
    padding: 10px 0 10px 0;
  }

  .pay-attention {
    -webkit-animation: glowing 1500ms infinite;
    -moz-animation: glowing 1500ms infinite;
    -o-animation: glowing 1500ms infinite;
    animation: glowing 1500ms infinite;
  }

  @-webkit-keyframes glowing {
    0% {
      background-color: rgb(21, 178, 0);
      -webkit-box-shadow: 0 0 3px rgb(21, 178, 0);
    }

    50% {
      background-color: rgb(0, 255, 34);
      -webkit-box-shadow: 0 0 40px rgb(0, 255, 34);
    }

    100% {
      background-color: rgb(21, 178, 0);
      -webkit-box-shadow: 0 0 3px rgb(21, 178, 0);
    }
  }

  @-moz-keyframes glowing {
    0% {
      background-color: rgb(21, 178, 0);
      -moz-box-shadow: 0 0 3px rgb(21, 178, 0);
    }

    50% {
      background-color: rgb(0, 255, 34);
      -moz-box-shadow: 0 0 40px rgb(0, 255, 34);
    }

    100% {
      background-color: rgb(21, 178, 0);
      -moz-box-shadow: 0 0 3px rgb(21, 178, 0);
    }
  }

  @-o-keyframes glowing {
    0% {
      background-color: rgb(21, 178, 0);
      box-shadow: 0 0 3px rgb(21, 178, 0);
    }

    50% {
      background-color: rgb(0, 255, 34);
      box-shadow: 0 0 40px rgb(0, 255, 34);
    }

    100% {
      background-color: rgb(21, 178, 0);
      box-shadow: 0 0 3px rgb(21, 178, 0);
    }
  }

  @keyframes glowing {
    0% {
      background-color: rgb(21, 178, 0);
      box-shadow: 0 0 3px rgb(21, 178, 0);
    }

    50% {
      background-color: rgb(0, 255, 34);
      box-shadow: 0 0 40px rgb(0, 255, 34);
    }

    100% {
      background-color: rgb(21, 178, 0);
      box-shadow: 0 0 3px rgb(21, 178, 0);
    }
  }

  .vs__dropdown-menu {
    max-height: 19vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
  }

</style>
